import { OffsetPaginationMetaEntity } from "@/entities/OffsetPaginationEntity";
import ReviewEntity from "@apps/reviews/entities/ReviewEntity";

import { ReviewsSdkDto } from "../types";
import { mapReviewItemToSdkDto } from "./mapReviewItemToSdkDto";
import { mapReviewsPaginationMetaToSdkDto } from "./mapReviewsPaginationMetaToSdkDto";

export function mapReviewsToSdkDto(
    reviews: ReviewEntity[],
    paginationMeta: OffsetPaginationMetaEntity
): ReviewsSdkDto {
    return {
        items: reviews.map(mapReviewItemToSdkDto),
        ...mapReviewsPaginationMetaToSdkDto(paginationMeta),
    };
}
